'use client';

import Blurb from '@commons/Blurb/Blurb';
import './_section.scss';
import HtmlToJsx from '@commons/HtmlToJsx/HtmlToJsx';
import useDictionary from '@modules/Dictionary/useDictionary';

export default function Section({ sectionId = '', children = <></>, package_data = null }) {
  const { dictionary } = useDictionary();
  return (
    <section className="Section" id={sectionId}>
      <div className="Section__main">
        <HtmlToJsx html={children} />
      </div>
      {package_data ? (
        <aside className="Section__aside">
          <Blurb>
            <Blurb.Image src={package_data.image} alt={package_data.title} />
            <Blurb.Content>
              <Blurb.Title>{package_data.title}</Blurb.Title>
              <Blurb.Description>
                <HtmlToJsx html={package_data.excerpt} />
              </Blurb.Description>
              <Blurb.Actions>
                <Blurb.CTA
                  primaryText={package_data.cta_label}
                  primaryHref={package_data.cta_url}
                  secondaryText={dictionary.product.readMore}
                  secondaryHref={package_data.info_url}
                />
              </Blurb.Actions>
            </Blurb.Content>
          </Blurb>
        </aside>
      ) : null}
    </section>
  );
}
